import { Injectable } from '@angular/core'
import { ToastController } from 'ionic-angular';

@Injectable()

export class Globales {


  constructor(public toastCtrl:ToastController){

  }

  toFormData(data:Object){

    let form:FormData = new FormData();

    for(let item in data){

      form.append(item, data[item]);
    }
    return form;
  }


  showToast(mensaje, duration){

    if(mensaje && duration){

      let toast = this.toastCtrl.create({
        cssClass:'restmar',
        showCloseButton: false,
        closeButtonText: 'Ok',
        message: mensaje,
        duration: duration,
        position: 'middle'
      });
      toast.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/classes/funciones.ts